module.exports = __webpack_public_path__ + "img/yu@2x.e8a7210e.png";